var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 18,
    height: 18,
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(3.55556,3.55556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.949,67.053c-5.514,0 -10,-4.486 -10,-10c0,-5.514 4.486,-10 10,-10c5.514,0 10,4.486 10,10c0,5.514 -4.486,10 -10,10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.04,47.002c-5.514,0 -10,-4.486 -10,-10c0,-5.514 4.486,-10 10,-10c5.514,0 10,4.486 10,10c0,5.514 -4.486,10 -10,10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.682,36.681l7.789,10.735c0.749,1.098 0.218,3.198 -1.747,4.543c-1.897,1.298 -4.472,0.542 -4.843,-0.1l-7.939,-10.834l-11.674,-0.1c-1.104,0 -3.355,-1.248 -3.355,-3.9c0,-2.44 2.25,-3.988 3.355,-3.988h11.224l6.69,-10.285c0.553,-0.956 3.495,-1.648 5.043,-0.749c2.454,1.425 2.299,4.236 1.747,5.193z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.953,28.053c-5.514,0 -10,-4.486 -10,-10c0,-5.514 4.486,-10 10,-10c5.514,0 10,4.486 10,10c0,5.514 -4.486,10 -10,10z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.a462025a96b6343d5db64b287b296c16.svg";
export { ForwardRef as ReactComponent };